import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    actionsGrid: { display: 'flex', alignItems: 'center' },
    header: { marginTop: 16 },
    publicationInfoNoticeGrid: {
      width: '100%',
      marginTop: 8,
      marginBottom: 8,
      paddingRight: 30,
    },
    publicationInfoNotice: {
      width: '100%',
      fontSize: 14,
      backgroundColor: 'rgba(0, 116, 217, 0.06)',
      color: 'rgba(0, 0, 0, 0.7)',
      border: `1px solid ${palette.autoSkyBlue}`,
      boxShadow: 'none',
      '& .MuiAlert-icon': {
        color: palette.autoSkyBlue,
      },
    },
    publicationInfoNoticeText: { fontSize: 14, lineHeight: 1.6 },
    selectorTextGrid: { margin: 8 },
    selectorText: { fontSize: 14 },
    alert: {
      width: 'fit-content',
      margin: 32,
      fontSize: 12,

      '& b': {
        fontWeight: 900,
      },
    },
    blockActionsDescription: { fontSize: 12 },
    alertText: { fontSize: 14 },
    loadingContainer: { marginTop: 64 },
    buttonsBlockServerActions: { margin: '8px 0px' },
  });
